import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

import { cn } from '@common/lib/utils';

const badgeVariants = cva(
  `tw-inline-flex tw-items-center tw-rounded-full tw-border tw-px-2.5 tw-leading-6 tw-py-0.5 tw-text-xs tw-font-semibold
  tw-transition-colors focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-ring focus:tw-ring-offset-2`,
  {
    variants: {
      variant: {
        default:
          'tw-border-transparent tw-bg-primary tw-text-primary-foreground tw-w-[60px] hover:tw-bg-primary/80 tw-rounded-lg',
        secondary:
          'tw-border-transparent tw-bg-secondary tw-text-secondary-foreground hover:tw-bg-secondary/80 tw-rounded-lg',
        destructive:
          'tw-border-transparent tw-bg-destructive tw-text-destructive-foreground hover:tw-bg-destructive/80 tw-rounded-lg',
        outline: 'tw-text-foreground tw-rounded-lg',
        live: 'tw-border-transparent tw-bg-blue-light tw-text-blue-custom tw-w-[60px] tw-justify-center tw-rounded-lg',
        completed: 'tw-border-transparent tw-bg-green-light tw-text-green-custom tw-w-[60px] tw-justify-center tw-rounded-lg',
        paused: 'tw-border-transparent tw-bg-orange-light tw-text-orange-custom tw-w-[60px] tw-justify-center tw-rounded-lg',
        archived: 'tw-border-transparent tw-bg-gray-custom-400 tw-text-white tw-w-[60px] tw-justify-center tw-rounded-lg',
        draft: 'tw-border-transparent tw-bg-gray-custom-100 tw-text-gray-custom-500 tw-w-[60px] tw-justify-center tw-rounded-lg',
        scheduled: `tw-border-transparent tw-bg-gray-custom-100 tw-text-gray-custom-500 tw-w-[60px] tw-justify-center
         tw-rounded-lg`,
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
